/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function MoonIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="moon"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M21.5 12A9.5 9.5 0 1 1 12 2.5" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 0 270 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M21.5 12A6.718 6.718 0 0 1 12 2.5" data-tinysvg-shape="arc" data-tinysvg-arc="16.75 7.25 6.718 6.718 45 225 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
